import moment from 'moment/moment';
import { Link } from 'react-router-dom';
import EIT from '../assets/images/EITlogo.jpg';
import { BsFacebook, BsInstagram, BsLinkedin } from 'react-icons/bs';

const companyLinks = [
  { label: 'Home',           to: '/' },
  { label: 'About Us',      to: '/about' },
  { label: 'Services',      to: '/services' },
  { label: 'Careers',       to: '/careers' },
  { label: 'News & Events', to: '/news-and-events' },
];

const contactLinks = [
  { label: 'Contact Us',        to: '/contact',              isRoute: true },
  { label: '+233 24 050 2834',  href: 'tel:+233240502834' },
  { label: 'info@eitghana.com', href: 'mailto:info@eitghana.com' },
];

const socialLinks = [
  { Icon: BsLinkedin,  href: 'https://www.linkedin.com/company/eit-ghana-limited', label: 'LinkedIn' },
  { Icon: BsFacebook,  href: 'https://web.facebook.com/eitghanalimited',           label: 'Facebook' },
  { Icon: BsInstagram, href: 'https://www.instagram.com/eitghanalimited',          label: 'Instagram' },
];

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-5 lg:px-20 py-12">

        {/* Top grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">

          {/* Brand card */}
          <div className="lg:col-span-2 bg-white rounded-3xl p-8 shadow-sm">
            <img src={EIT} className="h-12 mb-5" alt="EIT Logo" />
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs mb-6">
              EIT Ghana Limited is your all-in-one hub for technology services, entrepreneurship
              training, venture capital, and marketing solutions.
            </p>
            <div className="flex gap-2">
              {socialLinks.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-blueblack hover:text-white transition-all duration-200"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>

          {/* Company card */}
          <div className="bg-white rounded-3xl p-8 shadow-sm">
            <h3 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-5">Company</h3>
            <ul className="flex flex-col gap-3">
              {companyLinks.map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-gray-600 hover:text-blueblack text-sm font-medium transition-colors duration-200"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact card */}
          <div className="bg-blueblack rounded-3xl p-8">
            <h3 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-5">Contact</h3>
            <ul className="flex flex-col gap-3">
              {contactLinks.map(({ label, to, href, isRoute }) => (
                <li key={label}>
                  {isRoute ? (
                    <Link to={to} className="text-gray-300 hover:text-yellowcolor text-sm font-medium transition-colors duration-200">
                      {label}
                    </Link>
                  ) : (
                    <a href={href} className="text-gray-300 hover:text-yellowcolor text-sm transition-colors duration-200">
                      {label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-sm">
            © {moment().format('YYYY')} EIT Ghana Limited. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm">
            Developed with{' '}
            <span className="text-red-400">♥</span>{' '}
            by{' '}
            <a
              href="https://www.eitghana.com"
              target="_blank"
              rel="noreferrer"
              className="text-seablue hover:text-blueblack transition-colors font-semibold"
            >
              EIT Ghana Limited
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
